const ordenLaboratorioInitialState = {
    ordenLaboratorio: {
        loading: false,
        error: null,
        data: null,
        eliminado: null
    },
};

export default ordenLaboratorioInitialState;